<script setup>
import Button from "@/Components/Button.vue";
import {computed} from "vue";

const props = defineProps({
    type: {
        type: String,
        default: 'default'
    },
    text: String
})

const classesBtn = computed(() => {
    return {
        'default': 'text-slate-500 group-hover:text-black dark:group-hover:text-slate-200',
        'danger': 'text-red-500 group-hover:text-red-600',
        'success': 'text-green-600',
        'primary': 'text-blue-600'
    }[props.type]
})

</script>

<template>
    <button :class="classesBtn" class="flex gap-1 items-center group leading-full">
        <slot name="icon"></slot>
        <span :class="classesBtn" class="text-xs underline transition-colors leading-full">{{ text }}</span>
    </button>
</template>

<style scoped>

</style>
